import { Cluster } from "in_queue/types/clusterType";

/**
 * The cluster-routing fields stamped onto a new scenario.
 *
 * These MUST come from the portfolio cluster the user is operating in (the
 * `in_queue_clusters` row behind the route, via `useCluster()`), NOT from the
 * project's own `cluster`. A queue project carries its *native* MISO study
 * group (e.g. "Central"), whereas MISO `default_group`-aggregated cycles
 * (DPP-2023/2025) run under a single `default_group` Dagster cluster. Stamping
 * the project's native group produces a scenario whose `study_group` matches no
 * registered job, so the in-queue kickoff sensor silently drops it and it never
 * runs. See scenarioClusterFields.test.ts.
 */
export const getScenarioClusterFields = (
    cluster: Cluster
): {
    region: string;
    studyGroup: string;
    studyCycle: string;
    studyPhase: string;
} => ({
    region: cluster.region,
    studyGroup: cluster.studyGroup,
    studyCycle: cluster.studyCycle,
    studyPhase: cluster.studyPhase
});
